export const isFullStatic = false
export const staticPath = "/mnt/datas/appwechat.bekaert.cn/.nuxt/static-json"
export const publicPath = "/spring-wire/"
export const globalContext = "__NUXT__"
export const globalNuxt = "$nuxt"